import { SortableHandle } from "react-sortable-hoc";
import DragIcon from "./DragIcon";

export const DragHandler = SortableHandle(() => <span className="dragdrop-option">
    {/* <img src="/images/grip-vertical.svg" className="drag-img" alt='' /> */}
    <DragIcon />

  </span>);